import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit';

import { RequestStatus } from 'shared/constants/State';
import { ComplaintSearchResponse } from '../types';

interface InitialState {
  status: RequestStatus;
  data: ComplaintSearchResponse;
  error: string;
}

export const initialState: InitialState = {
  status: RequestStatus.Ready,
  data: {
    most_used: [],
    cid10: [],
  },
  error: '',
};

const name = 'medicalRecords/complaintsSearch';

const searchSlice = createSlice({
  name,
  initialState,
  reducers: {
    searchComplaintSuccess: (
      state,
      action: PayloadAction<ComplaintSearchResponse>,
    ) => ({
      ...state,
      data: action.payload,
      status: RequestStatus.Success,
      error: '',
    }),
    searchComplaintPending: (state) => ({
      ...state,
      status: RequestStatus.Pending,
      error: '',
    }),
    searchComplaintError: (state, action: PayloadAction<string>) => ({
      ...state,
      status: RequestStatus.Error,
      error: action.payload,
    }),
  },
});

export const {
  searchComplaintSuccess,
  searchComplaintPending,
  searchComplaintError,
} = searchSlice.actions;
export const searchComplaint = createAction<string>(`${name}/getSearch`);

export default searchSlice.reducer;
